import {Vector2} from 'three';

export class VectorMath {
    public static corner(v1: Vector2, v2: Vector2): number {
        return Math.atan((v2.y - v1.y) / (v2.x - v1.x));
    }
}
